(function() {
  "use strict";
  
  var SECTION_MAP = {
    "Product":    "section_p7Xq7E",
    "About":      "section_CYACYU",
    "Customized": "section_rUWfEL",
    "Quality":    "section_rWTJVM",
    "Process":    "section_UzY6DU"
  };
  
  var SCROLL_OFFSET = 80;
  var boundLinks = new WeakSet();
  
  function getScrollOffset() {
    var h = getComputedStyle(document.body).getPropertyValue("--header-height");
    var px = parseInt(h, 10);
    return px > 0 ? px : SCROLL_OFFSET;
  }
  
  function isHomepage() {
    var path = window.location.pathname;
    return path === "/" || path === "" || path === "/index";
  }
  
  // Find the actual scroll container
  function getScrollContainer() {
    // Check .page-wrapper first (used by this theme)
    var pw = document.querySelector(".page-wrapper");
    if (pw) {
      var style = getComputedStyle(pw);
      if (style.overflowY === "auto" || style.overflowY === "scroll" || pw.scrollHeight > pw.clientHeight) {
        return pw;
      }
    }
    // Fall back to document.scrollingElement
    return document.scrollingElement || document.documentElement;
  }
  
  function findSection(key) {
    return document.querySelector('[id*="' + key + '"]');
  }
  
  function scrollToSection(key) {
    var el = findSection(key);
    if (!el) return;
    
    var container = getScrollContainer();
    var isWindow = (container === document.documentElement || container === document.scrollingElement);
    
    if (isWindow) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
      window.scrollTo({ top: top, behavior: "smooth" });
    } else {
      var containerRect = container.getBoundingClientRect();
      var elRect = el.getBoundingClientRect();
      var scrollTop = elRect.top - containerRect.top + container.scrollTop - getScrollOffset();
      container.scrollTo({ top: scrollTop, behavior: "smooth" });
    }
  }
  
  function bindLink(link, sectionKey) {
    if (boundLinks.has(link)) return;
    boundLinks.add(link);
    
    link.href = "javascript:void(0)";
    link.style.cursor = "pointer";
    link.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollToSection(sectionKey);
    });
  }
  
  function scanAndBind() {
    if (!isHomepage()) return;
    document.querySelectorAll(".menu-list__link").forEach(function(link) {
      var text = (link.textContent || "").trim();
      var sectionKey = SECTION_MAP[text];
      if (sectionKey) bindLink(link, sectionKey);
    });
  }
  
  // MutationObserver for dynamically rendered menu links
  new MutationObserver(function() { scanAndBind(); }).observe(document.documentElement, {
    childList: true, subtree: true
  });
  
  scanAndBind();
  document.addEventListener("DOMContentLoaded", scanAndBind);
  setTimeout(scanAndBind, 300);
  setTimeout(scanAndBind, 1000);
})();